const intro = (
  <>
    <p>
      <strong>Mapa Staży</strong> to narzędzie umożliwiające szybkie
      wyszukiwanie placówek oferujących staże podyplomowe. Użytkownicy mają
      dostęp do aktualnej bazy miejsc szkoleniowych wraz z opiniami osób, które
      już odbyły tam staż.
    </p>

    <p>
      Platforma pozwala na filtrowanie wyników według lokalizacji, specjalizacji
      oraz ocen użytkowników. Dzięki temu przyszli lekarze i lekarki mogą
      dokonać świadomego wyboru i wybrać placówkę najlepiej dopasowaną do ich
      potrzeb.
    </p>
  </>
);

const content = (
  <>
    <h3>Jak działa Mapa Staży?</h3>
    <p>
      Rozpoczynając staż podyplomowy, młodzi lekarze i lekarki stają przed
      ważnym wyborem zawodowym. <strong>Mapa Staży</strong> pozwala podjąć
      decyzję w oparciu o konkretne informacje – dostępność miejsc, warunki
      szkolenia, opinie innych stażystów oraz możliwości rozwoju.
    </p>
    <p>
      Użytkownicy mogą filtrować dostępne opcje według lokalizacji,
      specjalizacji i warunków oferowanych przez placówki. Czy szpital umożliwia
      rotacje na różnych oddziałach? Czy w danej placówce jest możliwość
      kontynuacji pracy po stażu? <strong>Mapa Staży</strong> dostarcza
      odpowiedzi na te pytania, eliminując przypadkowość w wyborze miejsca
      szkoleniowego.
    </p>

    <h3>Zweryfikowane opinie stażystów</h3>
    <p>
      <strong>Mapa Staży</strong> udostępnia zweryfikowane opinie osób, które
      już odbyły staż w danej placówce. Dzięki temu użytkownicy mogą dowiedzieć
      się, jak wygląda codzienna praca, jakie są warunki szkolenia i jaka jest
      atmosfera w zespole. To praktyczne informacje, które pomagają unikać
      wyboru miejsc, które nie spełniają oczekiwań.
    </p>

    <h3>Dlaczego warto korzystać z Mapy Staży?</h3>
    <ul>
      <li>
        <strong>Dostęp do zweryfikowanej bazy miejsc stażowych</strong> –
        szybkie wyszukiwanie i porównanie różnych opcji.
      </li>
      <li>
        <strong>Filtracja według lokalizacji i specjalizacji</strong> –
        możliwość dostosowania wyników do indywidualnych potrzeb.
      </li>
      <li>
        <strong>Opinie użytkowników</strong> – rzetelne informacje o warunkach
        pracy i jakości szkolenia.
      </li>
    </ul>

    <h3>Podsumowanie – Świadomy wybór miejsca stażu</h3>
    <p>
      <strong>Mapa Staży</strong> to narzędzie, które pomaga przyszłym lekarzom
      i lekarkom podejmować świadome decyzje dotyczące kariery. Przejrzysta
      struktura, filtrowanie wyników i zweryfikowane opinie użytkowników
      sprawiają, że wybór placówki staje się prostszy i bardziej przejrzysty.
    </p>
    <p>
      Skorzystać z narzędzia, które dostarcza aktualnych i wiarygodnych
      informacji, ułatwiając wybór miejsca, w którym staż będzie rzeczywistą
      wartością dla przyszłej kariery medycznej.
    </p>
  </>
);

export const internshipMapDescription = { intro, content };
